import React from 'react';

import PropertyCardContent from 'bundles/crm/properties/card/content';
import Thumbnail from 'bundles/crm/properties/thumbnail';
import { convertToEdgeCrmProperty } from 'bundles/research/index/helpers';

import type { Props } from './types';
import type { Property } from 'bundles/research/index/properties/types';

export default function EdgeCrmMapListItem({
  googleMapsApiKey,
  isSelected,
  record,
  onClick,
  onSelectionToggle,
  ...props
}: Props) {
  return (
    <div className="card" {...props}>
      <div className="card-body p-2">
        <div className="d-flex gap-2 align-items-start">
          <div className="flex-grow-0 flex-shrink-1 pt-1">
            <input
              checked={isSelected}
              className="form-check-input"
              type="checkbox"
              onChange={onSelectionToggle}
            />
          </div>

          <div className="flex-fill">
            <PropertyCardContent
              property={convertToEdgeCrmProperty(record as Property)}
              onClick={onClick}
            />
          </div>

          <div className="flex-grow-0 flex-shrink-0 rounded overflow-hidden property-thumbnail">
            <Thumbnail
              autoHeight
              googleMapsApiKey={googleMapsApiKey}
              height={93}
              property={record as Property}
              width={140}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
